import styled, { css } from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import AboutComponent from './components/about-store';
import UserReviewCardComponent from '../../components/user-review-card';
import UserReviewPromptComponent from '../reviews/components/prompt';
import Notification from './components/notification';

import NotificationNew from '../../components/notification';
import SideColumnComponent from './components/side-column';
import { SECTION_TITLE_SIZE } from './constants';

const sectionContainerPadding = `0 ${layout.measurements.spacing100}`;

export const ShopPage = styled.div.attrs({ 'data-test': 'StorePage' })`
  display: flex;
  flex-direction: column;
  column-gap: ${layout.measurements.spacing100};
  max-width: ${layout.siteWidth.rem};
`;

export const ReviewsSection = styled.section`
  display: flex;
  flex-direction: row;
  margin: ${layout.measurements.spacing100} 0;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 70% 30%;
  }

  ${media.mediumDown`
    @supports (display: grid) {
      grid-template-columns: 1fr;
      row-gap: ${layout.measurements.spacing150};
    }
    
    flex-direction: column;
  `};
`;

export const AboutSection = styled.section`
  margin-bottom: ${layout.measurements.spacing150};
`;

export const Main = styled.div`
  order: 0;
  padding: ${sectionContainerPadding};
  width: 70%;

  @supports (display: grid) {
    width: auto;
  }

  ${media.mediumDown`
    width: 100%;
    order: 1;
  `};
`;

export const SideColumn = styled(SideColumnComponent)`
  order: 1;
  padding: ${sectionContainerPadding};
  width: 30%;

  @supports (display: grid) {
    width: auto;
  }

  ${media.mediumDown`
    width: 100%;
    order: 0;
  `};
`;

export const SectionTitle = styled.h2(
  props => css`
    display: flex;
    align-items: center;
    font-size: ${remCalc(SECTION_TITLE_SIZE)};
    border-bottom: 1px solid ${props.theme.lines.secondary};
    padding-bottom: ${layout.measurements.spacing100};
    margin-top: ${layout.measurements.spacing050};
    margin-left: ${layout.measurements.spacing050};
    margin-right: ${layout.measurements.spacing050};
    padding-left: ${layout.measurements.spacing050};
    padding-right: ${layout.measurements.spacing050};

    ${media.smallOnly`
      margin-left: 0;
      margin-right: 0;
      padding-left: ${layout.measurements.spacing100};
      padding-right: ${layout.measurements.spacing100};
    `}
  `
);

export const Count = styled.span(
  props => css`
    font-size: ${layout.measurements.fontSizeNormal};
    color: ${props.theme.text.quaternary};
    margin-left: ${layout.measurements.spacing050};
    font-weight: normal;
  `
);

export const UserReviewCard = styled(UserReviewCardComponent)`
  grid-template-columns: 0 3fr 0;
  padding: ${layout.measurements.spacing100} 0;
`;

export const About = styled(AboutComponent)`
  padding: ${sectionContainerPadding};
  margin-top: ${layout.measurements.spacing100};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing100};
`;

export const PromptButton = styled(Button)`
  font-weight: normal;
  text-transform: none;
  width: 100%;
  max-width: 350px;
`;

export const UserReviewPrompt = styled(UserReviewPromptComponent)`
  margin: ${layout.measurements.spacing100} 0;
`;

export const NeutralNotification = styled(Notification)`
  margin-bottom: ${layout.measurements.spacing050};
`;

export const AnalyticsNotification = styled(Notification)`
  margin: ${layout.measurements.spacing050};
`;

export const VerifyNotification = styled(NotificationNew)`
  margin: ${layout.measurements.spacing050};
`;
